module.exports = __webpack_public_path__ + "static/media/food4.398f1815.png";